import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';

function VideosInDari() {
  return (
    <>
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-white transition">
      <Navbar />
      <div className="pt-24 px-6 max-w-5xl mx-auto">
        <br />
        <h2 className="text-2xl font-bold mb-6">Featured Videos</h2>
        <motion.div className="grid md:grid-cols-2 gap-6">
        <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">MySQL Shell Explained In Farsi (Dari)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/oY2SjhD3VKE"
            title="MySQL Shell Explained In Farsi (Dari)"
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Python + R + MariaDB + SQL In Farsi (Dari)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/DULCd86odCc"
            title="Python, R, MariaDB and SQL in Farsi (Dari)"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">The story of Alkhawariz (Algorithm)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/wPCCUj2fb_Y"
            title="The story of Alkhawariz (Algorithm)"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Operating System In Farsi (Dari)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/IZ2OBuYzxbM"
            title="Operating System In Farsi (Dari)"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Introduction to Windows OS (Dari)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/cukKlitXXLc"
            title="Introduction to Windows OS (Dari)"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          <div className="mt-10">
          <h3 className="text-xl font-semibold mb-3">Python Programming In Farsi (Dari)</h3>
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src="https://www.youtube.com/embed/DfQQb8QJh-A"
            title="Python Programming In Farsi (Dari)"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
        </motion.div>

          <iframe
            className="w-full aspect-video rounded-lg shadow-lg"
            src="https://www.MyWebUniversity.com/youtube-channels1w.html" 
            title="MyWebUniversity"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>
          </div>
    </>
  );
}
export default VideosInDari;
